export default __webpack_public_path__ + "static/media/ourStory2.17749bfb.png";